module.exports = __webpack_public_path__ + "img/4-1_06.f70eb63a.jpg";